import React from 'react';
import { Box, Typography, Button, Card, CardMedia, CardContent, Stack } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder'; // For interested button icon
import { IEvent } from '../../types/global/helper';
import { formatDateWithTimezone } from '../../utils/AppUtils';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CustomButton from '../Button/CustomButton';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import AlternateShareIcon from '../CustomSVGIcons/AlternateShareIcon';

interface IEventCard {
    event: IEvent;
    onClickEvent: () => void;
    onRecommendationClick: () => void;
}
const EventCard: React.FC<IEventCard> = ({ event, onClickEvent, onRecommendationClick }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Card
            sx={{
                maxWidth: {
                    xs: '100%',
                    sm: 345,
                },
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: theme[themeStyle].secondaryBg,
            }}>
            {/* Event Image */}
            <Box sx={{ position: 'relative' }}>
                {!event.feature_image && event.is_background_color && event.background_color && (
                    <Box sx={{ overflow: 'hidden', height: '120px', background: event.background_color }}></Box>
                )}
                {event.feature_image && (
                    <CardMedia
                        component="img"
                        image={event.feature_image}
                        alt={event.name}
                        sx={{ overflow: 'hidden', height: '120px' }}
                    />
                )}
            </Box>

            {/* Event Details */}
            <CardContent>
                {/* Date */}
                <Typography
                    variant="subtitle2"
                    color="error"
                    gutterBottom
                    sx={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 12 }}>
                    {formatDateWithTimezone(event.event_start_date, event.timezone)}
                </Typography>

                {/* Event Title */}
                <Typography
                    sx={{ fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 14, color: theme[themeStyle].tag_white }}
                    gutterBottom>
                    {event.name}
                </Typography>

                {/* Location */}
                <Typography variant="body2" color={theme[themeStyle].tag_white}>
                    {event.location.address}
                </Typography>

                {/* Interested Counter */}
                {!!event.total_attendance && event.total_attendance > 0 && (
                    <Typography variant="body2" sx={{ mt: 1 }} color={theme[themeStyle].tag_white}>
                        {event.total_attendance} people attending
                    </Typography>
                )}
            </CardContent>

            {/* Action Buttons */}
            <Box sx={{ px: 2, pb: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    {/* Interested Button */}
                    <CustomButton
                        label="Interested"
                        customStyle={{
                            borderRadius: '4px',
                        }}
                        sx={{ width: '100%' }}
                        withIcon
                        onClick={onClickEvent}
                        beginningIcon={
                            <StarBorderIcon sx={{ color: theme[themeStyle].zeus_dark, fontSize: 16, mr: 0.5 }} />
                        }
                        textStyle={{
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            fontSize: 14,
                        }}
                    />

                    {/* Share Icon */}
                    <Button
                        variant="text"
                        color="inherit"
                        onClick={onRecommendationClick}
                        sx={{ minWidth: 'auto', backgroundColor: theme[themeStyle].deep_grey, height: '40px', ml: 1 }}>
                        <AlternateShareIcon
                            height={'20px'}
                            width={'20px'}
                            stroke={theme[themeStyle].tag_white}
                            fill={theme[themeStyle].tag_white}
                        />
                    </Button>
                </Stack>
            </Box>
        </Card>
    );
};

export { EventCard };
